import Form from 'components/Form';

import { Fragment } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';
import { Stack } from '@mui/system';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const checks = [
  {
    label:
      'Không thể hiểu các điều khoản của thỏa thuận do bệnh nhân bị suy giảm về thể chất hoặc tinh thần.',
    key: 'no3_check_01',
  },
  {
    label:
      'Việc giải thích sẽ có tác động tiêu cực đáng kể đối với trạng thái tinh thần của bệnh nhân.',
    key: 'no3_check_02',
  },
  {
    label: 'Bệnh nhân ủy quyền cho một cá nhân cụ thể để chấp thuận.',
    key: 'no3_check_03',
  },
  {
    label: 'Khác',
    key: 'no3_check_04',
  },
];

const RecordInfo = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="3. Lý do có chữ ký của người giám hộ (Chỉ khi được ký bởi người giám hộ)" />
      <Box sx={{ margin: '48px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          {checks.map((v, i) => {
            if (v.label === 'Khác') {
              return (
                <Grid item xs={12}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                    <Form.MuiTextField
                      sx={{ marginLeft: '20px' }}
                      disabled={disabled}
                      required={false}
                      placeholder="Nhập thông tin"
                      {...register('no3_input_box')}
                    />
                  </Stack>
                </Grid>
              );
            }
            return (
              <Grid item xs={11.5}>
                <Form.MuiCheckbox
                  label={v.label}
                  disabled={disabled}
                  defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                  onChange={(_, checked) => {
                    setValue(v.key, checked);
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
        <Typography
          sx={{ margin: '30px 0 20px 0', fontSize: '14px', fontWeight: 500 }}
        >
          Sau khi nghe giải thích, bệnh nhân/người giám hộ đã nhận đủ thông tin
          về việc sử dụng sự kiềm chế bằng phương pháp vật lý và đồng ý với điều
          đó.
        </Typography>
      </Box>
    </>
  );
};

export default RecordInfo;
